// extracted by mini-css-extract-plugin
module.exports = {"range":"PositionRange_range__37c8m","track":"PositionRange_track__29LQE"};